<template>
  <div class="dashboard-container">
    <!-- 欢迎栏 -->
    <div class="welcome-section">
      <div class="welcome-text">
        <h2>欢迎使用数据采集平台</h2>
        <!-- <p>{{ NowDate }}</p> -->
      </div>
    </div>

    <!-- 设备状态统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-blue">
          <div class="stat-icon">
            <i class="el-icon-video-play"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Production || 0 }}</div>
            <div class="stat-label">生产中</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-orange">
          <div class="stat-icon">
            <i class="el-icon-loading"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Standby || 0 }}</div>
            <div class="stat-label">待机中</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-red">
          <div class="stat-icon">
            <i class="el-icon-warning"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Fault || 0 }}</div>
            <div class="stat-label">故障中</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-gray">
          <div class="stat-icon">
            <i class="el-icon-video-pause"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Shutdown || 0 }}</div>
            <div class="stat-label">关机中</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 快捷入口 -->
    <div class="quick-access-section" v-if="hasQuickAccess">
      <!-- 监控分析区块 -->
      <div class="menu-block" v-if="hasMenuPermission('monitor', 'monitor')">
        <div class="block-header">
          <div class="block-icon monitor-icon">
            <i class="el-icon-monitor"></i>
          </div>
          <div class="block-title">监控分析</div>
        </div>
        <div class="block-content">
          <div class="menu-item" v-for="menu in getMenusByKeyword('监控分析')" :key="menu.MenuId" @click="navigateToMenu(menu)">
            <div class="menu-item-icon" :class="getMenuIconClass(menu)">
              <i :class="getMenuIcon(menu)"></i>
            </div>
            <div class="menu-item-text">{{ menu.MenuName }}</div>
          </div>
          <div class="no-menu" v-if="getMenusByKeyword('监控分析').length === 0">
            暂无子菜单
          </div>
        </div>
      </div>

      <!-- 设备管理区块 -->
      <div class="menu-block" v-if="hasMenuPermission('facility', 'equipment')">
        <div class="block-header">
          <div class="block-icon facility-icon">
            <i class="el-icon-setting"></i>
          </div>
          <div class="block-title">设备管理</div>
        </div>
        <div class="block-content">
          <div class="menu-item" v-for="menu in getMenusByKeyword('设备管理')" :key="menu.MenuId" @click="navigateToMenu(menu)">
            <div class="menu-item-icon" :class="getMenuIconClass(menu)">
              <i :class="getMenuIcon(menu)"></i>
            </div>
            <div class="menu-item-text">{{ menu.MenuName }}</div>
          </div>
          <div class="no-menu" v-if="getMenusByKeyword('设备管理').length === 0">
            暂无子菜单
          </div>
        </div>
      </div>

      <!-- 人力管理区块 -->
      <div class="menu-block" v-if="hasMenuPermission('personnel', 'employee')">
        <div class="block-header">
          <div class="block-icon personnel-icon">
            <i class="el-icon-user-solid"></i>
          </div>
          <div class="block-title">人力管理</div>
        </div>
        <div class="block-content">
          <div class="menu-item" v-for="menu in getMenusByKeyword('人力管理')" :key="menu.MenuId" @click="navigateToMenu(menu)">
            <div class="menu-item-icon" :class="getMenuIconClass(menu)">
              <i :class="getMenuIcon(menu)"></i>
            </div>
            <div class="menu-item-text">{{ menu.MenuName }}</div>
          </div>
          <div class="no-menu" v-if="getMenusByKeyword('人力管理').length === 0">
            暂无子菜单
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import equipmentApi from '@/api/ba/equipment'

export default {
  name: 'home',
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require('@/api/sy/user').default,
      deviceStatus: {
        Production: 0,
        Standby: 0,
        Fault: 0,
        Shutdown: 0
      },
      NowDate: this.$commonJs.getToday(),
      refreshTimer: null
    }
  },
  computed: {
    // 判断是否有快捷入口
    hasQuickAccess() {
      return this.hasMenuPermission('monitor', 'monitor') ||
             this.hasMenuPermission('facility', 'equipment') ||
             this.hasMenuPermission('personnel', 'employee')
    }
  },
  mounted() {
    this.getData()
    // 设置5分钟定时刷新
    this.refreshTimer = setInterval(() => {
      this.getData()
    }, 300000) // 5分钟 = 300000毫秒
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    getData() {
      // 获取设备状态统计
      this.getDeviceStatus()
    },
    getDeviceStatus() {
      equipmentApi.getOperatingTypes({}).then(res => {
        if (res.Data) {
          this.deviceStatus.Production = res.Data.onLineCount || 0
          this.deviceStatus.Standby = res.Data.waitCount || 0
          this.deviceStatus.Fault = res.Data.faultCount || 0
          this.deviceStatus.Shutdown = res.Data.offLineCount || 0
        }
      }).catch(err => {
        console.error('获取设备状态失败:', err)
      })
    },
    // 判断是否有菜单权限
    hasMenuPermission(module, pageKeyword) {
      const menus = this.$store.state.sys.permissionMenus
      if (!menus || menus.length === 0) return false

      // 检查是否存在该模块的父菜单
      const modulePath = `/${module}`
      return menus.some(menu => menu.FullPath === modulePath)
    },
    // 根据父菜单路径获取子菜单列表
    getMenusByParentPath(parentPath) {
      const menus = this.$store.state.sys.permissionMenus
      if (!menus || menus.length === 0) return []

      // 找到所有以父路径开头的菜单（排除父菜单本身）
      return menus.filter(menu => {
        return menu.FullPath &&
               menu.FullPath.startsWith(parentPath) &&
               menu.FullPath !== parentPath &&
               menu.FullPath.length > parentPath.length &&
               !menu.FullPath.substring(parentPath.length + 1).includes('/')
      })
    },
    // 根据关键字获取菜单列表
    getMenusByKeyword(keyword) {
      const menus = this.$store.state.sys.permissionMenus
      if (!menus || menus.length === 0) return []

      // 定义关键字到父路径的映射
      const pathMap = {
        '监控': '/monitor',
        '监控分析': '/monitor',
        '设备管理': '/facility',
        '人力': '/personnel',
        '人力管理': '/personnel'
      }

      const parentPath = pathMap[keyword]
      if (!parentPath) return []

      return this.getMenusByParentPath(parentPath)
    },
    // 根据菜单获取图标
    getMenuIcon(menu) {
      if (!menu) return 'el-icon-menu'

      const url = menu.Url || ''
      const name = menu.MenuName || ''

      // 监控分析模块图标
      if (url === 'overview' || name.includes('总览')) return 'el-icon-data-board'
      if (url === 'devicestate' || name.includes('状态')) return 'el-icon-monitor'
      if (url === 'failure' || name.includes('故障')) return 'el-icon-warning'
      if (url === 'analysis' || name.includes('分析')) return 'el-icon-data-line'

      // 设备管理模块图标
      if (url === 'record' && name.includes('模具')) return 'el-icon-box'
      if (url === 'manage' && name.includes('设备管理')) return 'el-icon-setting'
      if (url === 'datathreshold' || name.includes('阈值')) return 'el-icon-s-tools'
      if (url === 'mold' || name.includes('档案')) return 'el-icon-goods'
      if (url === 'molduse' || name.includes('使用')) return 'el-icon-sold-out'

      // 人力管理模块图标
      if (url === 'dp' || name.includes('部门')) return 'el-icon-s-grid'
      if (url === 'record' && name.includes('员工')) return 'el-icon-s-custom'
      if (name.includes('考勤')) return 'el-icon-date'

      // 默认图标
      if (name.includes('管理')) return 'el-icon-setting'

      return 'el-icon-menu'
    },
    // 根据菜单获取图标颜色类
    getMenuIconClass(menu) {
      if (!menu) return ''

      const url = menu.Url || ''
      const name = menu.MenuName || ''

      // 监控分析模块图标
      if (url === 'overview') return 'icon-blue'
      if (url === 'devicestate') return 'icon-purple'
      if (url === 'failure') return 'icon-red'
      if (url === 'analysis') return 'icon-orange'

      // 设备管理模块图标
      if (url === 'manage') return 'icon-blue'
      if (url === 'datathreshold') return 'icon-green'
      if (url === 'mold') return 'icon-purple'
      if (url === 'molduse') return 'icon-orange'
      if (url === 'record' && name.includes('模具')) return 'icon-red'
      if (url === 'record' && name.includes('使用')) return 'icon-blue'

      // 人力管理图标
      if (url === 'dp') return 'icon-orange'
      if (url === 'record' && name.includes('员工')) return 'icon-green'

      return 'icon-default'
    },
    // 跳转到指定菜单
    navigateToMenu(menu) {
      if (menu.FullPath) {
        this.$router.push(menu.FullPath)
      } else if (menu.Url) {
        // 如果没有FullPath，尝试构建路径
        this.$router.push(`/${menu.Url}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 24px;
  background-color: #ffffff;
  min-height: calc(100vh - 84px);
  overflow: auto;
}

// 欢迎栏
.welcome-section {
  background: linear-gradient(135deg, #409EFF 0%, #53a8ff 50%, #66b1ff 100%);
  border-radius: 12px;
  padding: 24px 32px;
  margin-bottom: 32px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.3);

  .welcome-text {
    h2 {
      margin: 0;
      font-size: 26px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }

    p {
      margin: 4px 0 0 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.85);
    }
  }
}

// 快捷入口区域
.quick-access-section {
  margin-bottom: 32px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}

// 菜单区块
.menu-block {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid #f0f0f0;

  &:hover {
    border-color: #409EFF;
    box-shadow: 0 8px 30px rgba(64, 158, 255, 0.15);
  }
}

// 区块头部
.block-header {
  padding: 20px 24px;
  display: flex;
  align-items: center;
  color: #303133;
  background: #fafafa;
  border-bottom: 2px solid #f0f0f0;

  .block-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin-right: 16px;

    &.monitor-icon {
      background: #409EFF;
      color: white;
    }

    &.facility-icon {
      background: #67C23A;
      color: white;
    }

    &.personnel-icon {
      background: #E6A23C;
      color: white;
    }
  }

  .block-title {
    font-size: 18px;
    font-weight: 700;
  }
}

// 区块内容
.block-content {
  padding: 16px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

// 菜单项
.menu-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #ffffff;
  border: 2px solid #f0f0f0;

  &:hover {
    background: #40a0ff80;
    border-color: #409EFF;
    transform: translateX(8px);

    .menu-item-text {
      color: white;
    }

    .menu-item-icon {
      background: rgba(255, 255, 255, 0.25);
      color: #FFFFFF;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
  }

  .menu-item-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-right: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &.icon-blue {
      background: #409EFF;
    }

    &.icon-purple {
      background: #909399;
    }

    &.icon-red {
      background: #F56C6C;
    }

    &.icon-orange {
      background: #E6A23C;
    }

    &.icon-green {
      background: #67C23A;
    }

    &.icon-default {
      background: #C0C4CC;
    }
  }

  .menu-item-text {
    font-size: 15px;
    color: #303133;
    font-weight: 600;
    transition: all 0.3s;
  }
}

// 无菜单提示
.no-menu {
  text-align: center;
  padding: 32px;
  color: #909399;
  font-size: 14px;
}

// 统计卡片行
.stats-row {
  margin-bottom: 32px;
}

.stat-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid #f0f0f0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 6px;
  }

  &:hover {
    // transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }

  .stat-icon {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin-right: 20px;
  }

  .stat-content {
    flex: 1;

    .stat-value {
      font-size: 36px;
      font-weight: 800;
      color: #303133;
      margin-bottom: 4px;
      line-height: 1;
    }

    .stat-label {
      font-size: 14px;
      color: #909399;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  // 不同颜色的卡片
  &.stat-blue {
    border-color: #409EFF;

    &::before {
      background: #409EFF;
    }

    .stat-icon {
      background: #409EFF;
      color: white;
    }
  }

  &.stat-orange {
    border-color: #E6A23C;

    &::before {
      background: #E6A23C;
    }

    .stat-icon {
      background: #E6A23C;
      color: white;
    }
  }

  &.stat-red {
    border-color: #F56C6C;

    &::before {
      background: #F56C6C;
    }

    .stat-icon {
      background: #F56C6C;
      color: white;
    }
  }

  &.stat-gray {
    border-color: #909399;

    &::before {
      background: #909399;
    }

    .stat-icon {
      background: #909399;
      color: white;
    }
  }
}

// 图表行
.chart-row {
  margin-bottom: 32px;
}

.chart-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  height: 400px;
  display: flex;
  flex-direction: column;
  border: 2px solid #f0f0f0;

  .chart-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f0f0f0;
    flex-shrink: 0;

    i {
      font-size: 22px;
      color: #409EFF;
      margin-right: 12px;
    }

    span {
      font-size: 17px;
      font-weight: 700;
      color: #303133;
    }
  }

  .no-data {
    text-align: center;
    padding: 120px 0;
    color: #909399;
    font-size: 14px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 响应式布局
@media screen and (max-width: 768px) {
  .dashboard-container {
    padding: 16px;
  }

  .welcome-section {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;

    .welcome-text h2 {
      font-size: 22px;
    }
  }

  .quick-access-section {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .stats-row {
    margin-bottom: 20px;

    .el-col {
      margin-bottom: 12px;
    }
  }

  .stat-card {
    padding: 20px;

    .stat-icon {
      width: 56px;
      height: 56px;
      font-size: 24px;
      margin-right: 16px;
    }

    .stat-content .stat-value {
      font-size: 28px;
    }
  }

  .block-header {
    padding: 16px;

    .block-icon {
      width: 40px;
      height: 40px;
      font-size: 20px;
    }

    .block-title {
      font-size: 16px;
    }
  }

  .chart-row {
    margin-bottom: 16px;

    .el-col {
      margin-bottom: 12px;
    }
  }
}

@media screen and (min-width: 769px) and (max-width: 1200px) {
  .quick-access-section {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>